/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { createContext, useContext } from 'react';

export interface ITooltipModalContext {
    isTooltipShown: boolean;
}

export const useTooltipModalContext = () => {
    const context = useContext<ITooltipModalContext>(TooltipModalContext);
    if (!context) {
        throw new Error(
            'Tooltip Modal compound components cannot be rendered outside the Tooltip Modal component',
        );
    }

    return context;
};

const TooltipModalContext = createContext<ITooltipModalContext>({
    isTooltipShown: false,
});

export default TooltipModalContext;
